import { cn } from '@/lib/utils';

// VRChatワールドを想起させる固定色（テーマ非依存）
const MOCK_PHOTO_COLORS = [
  'hsl(210,25%,28%)', // 夜景の青
  'hsl(35,30%,35%)', // 夕焼け
  'hsl(160,20%,30%)', // 自然の緑
  'hsl(280,15%,25%)', // 紫の空間
  'hsl(15,35%,32%)', // 暖かい室内
  'hsl(190,25%,27%)', // 水辺
  'hsl(45,30%,38%)', // 黄昏
  'hsl(330,18%,28%)', // ピンクの世界
  'hsl(0,20%,30%)', // 赤い部屋
  'hsl(260,20%,30%)', // 紫の夜
  'hsl(120,15%,25%)', // 深い森
  'hsl(200,30%,22%)', // 深海
  'hsl(50,25%,30%)', // 金色の世界
  'hsl(180,20%,25%)', // ターコイズ
  'hsl(300,15%,28%)', // マゼンタ
  'hsl(20,30%,30%)', // 茶色の空間
  'hsl(240,15%,25%)', // 紺碧
  'hsl(80,15%,28%)', // オリーブ
];

interface MockPhotoGridProps {
  columns?: number;
  cellCount?: number;
  variant?: 'light' | 'dark';
  selectedIndex?: number;
  showDates?: boolean;
  className?: string;
}

/**
 * MockPhotoGrid
 * VRChat写真風の色付きセルグリッド
 * Desktop/Webアプリモックアップで使用
 */
export function MockPhotoGrid({
  columns = 6,
  cellCount = 18,
  selectedIndex,
  showDates = false,
  className,
}: MockPhotoGridProps) {
  return (
    <div
      className={cn('grid gap-[3px] p-3', className)}
      style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
    >
      {Array.from({ length: cellCount }).map((_, index) => {
        const colorIndex = index % MOCK_PHOTO_COLORS.length;
        const isSelected = index === selectedIndex;

        return (
          <div
            key={index}
            className={cn(
              'aspect-square relative',
              isSelected && 'outline outline-2 outline-accent outline-offset-[-2px]'
            )}
            style={{ background: MOCK_PHOTO_COLORS[colorIndex] }}
          >
            {/* Date badge (only on first photo of each "day") */}
            {showDates && index % 6 === 0 && (
              <div className="absolute top-1 left-1 bg-black/70 text-white text-[8px] px-1.5 py-0.5 rounded-[2px]">
                Jan {15 - Math.floor(index / 6)}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
